import { render, staticRenderFns } from "./ClearingDetail.vue?vue&type=template&id=23d0b5e6&scoped=true&"
import script from "./ClearingDetail.vue?vue&type=script&lang=js&"
export * from "./ClearingDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d0b5e6",
  null
  
)

export default component.exports